module.exports = __webpack_public_path__ + "static/img/yjc.20b0222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yjc.jpg
// module id = Goil
// module chunks = 1